import {
    Component,
    Input,
    Output,
    OnInit,
    EventEmitter,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
} from "@angular/core";
import { distinctUntilChanged, Observable } from "rxjs";
import { Store } from "@ngrx/store";

import { EsignService } from "../../print/esign/esign.service";
import { DocumentState, Signature } from "../../store/document/state";
import { RootState } from "../../store/root";

@Component({
    selector: "sign-all-modal",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "sign-all-modal.component.html",
    styleUrls: ["./zurich-style.css", "./zurich.css", "./main.css"],
})
export class SignAllModal {
    @Output() signRequest = new EventEmitter<Signature>();

    public docState$: Observable<DocumentState>;
    public isVisible = false;

    constructor(
        private esignService: EsignService,
        public store: Store<RootState>,
        private cdr: ChangeDetectorRef,
    ) {
        this.docState$ = this.store
            .select((s) => s.document)
            .pipe(distinctUntilChanged());
    }

    public requestSignature(field: Signature) {
        this.signRequest.emit(field);
    }

    public open(): void {
        this.isVisible = true;
        // TODO: Put modal states into store
        this.cdr.detectChanges();
    }

    public close(): void {
        this.isVisible = false;
        this.cdr.detectChanges();
    }
}
